export const HEADER_TOOLTIPS = {
    date: 'Date item was started.',
    startTime: 'Time item was started.',
    endTime: 'Time item was completed.',
    duration: 'Total time elapsed between start time and end time.',
    quantity: 'Number of units in item.',
}